/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-29 15:43:45
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 11:01:17
 */
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
} from "antd"
import TextArea from "antd/lib/input/TextArea"
import _ from "lodash"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import {
  getPrinters,
  getPrintTemplateSettingUserList,
  initializePrintService,
  selectPrintServiceState,
} from "../../print/printSlice"
import styles from "../PrintSettingAll.module.css"
import txmImg from "../assets/blhIcon.png"
import { selectTenantName } from "../../../app/applicationSlice"
import { getGenderName } from "../../../models/user"
import {
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from "../../../models/datetime"
import {
  getPrintInitOneConfigAsync,
  getPrintRestoreConfigDefaultAsync,
  getPrintSettingDetailAsync,
  getPrintSettingEditOrYLAsync,
  getPrintSettingPurchAseacceptanceAsync,
  getPrintSettingSubmitAsync,
  getPrintSettingsyncTenantNameAsync,
} from "../PrintSettingAllSlice"
import { pinyin } from "pinyin-pro"
import { LoadingState } from "../../../models/common"
import { selectSettings } from "../../user/setting/settingSlice"
import { Checks } from "../../../models/setting"

export const InventoryPrintSetting = (props: {
  selectKey?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const settings = useSelector(selectSettings)

  const [selectButtonId, setSelectButtonId] = useState<any>("1")

  const [users, setUsers] = useState<any>([])

  const [elseUsers, setElseUsers] = useState<any>([])

  const [nurses, setNurses] = useState<any>([])

  const [detail, setDetail] = useState<any>()

  const [isMask, setIsMask] = useState(true)

  const [changeData, setChangeData] = useState<any>()

  const [buttonLoading, setButtonLoading] = useState(false)

  const initialized = useSelector(selectPrintServiceState)

  const [showAcceptanceUserTypeListFlag, setAcceptanceUserTypeListFlag] = useState(
    false
  ) //是否展示验收人员标志位

  const [acceptanceUserSignType, setAcceptanceUserSignType] = useState(false) //验收人

  const rkysdDataList = [
    {
      no: "000208",
      productInformation:
        settings?.[Checks.MLKG] == 1
          ? "阿苯达唑咀嚼⽚0.1g * 12⽚ /盒 /缓释胶囊 /广西白云山盈康药业有限公司"
          : "阿苯达唑咀嚼⽚0.1g /12⽚ /盒 /缓释胶囊 /广西白云山盈康药业有限公司",
      origin: "广西白云山盈康药业有限公司",
      lstdLicHolder: "杨静云",
      approvalNumber: "国药准字H45021041",
      batchNo: "",
      arrivalUnitPrice: "13.40000",
      retailPrice: "14.50000",
      productDate: "20250803",
      deadline: "20290806",
      totalQuantity: "100",
      qualifiedQuantity: "100",
      defectiveQuantity: "0",
      qualityStatus: "良好",
      acceptanceConclusion: "合格",
      remark: "",
    },
    {
      no: "000208",
      productInformation:
        settings?.[Checks.MLKG] == 1
          ? "阿苯达唑咀嚼⽚0.1g * 12⽚ /盒 /缓释胶囊 /广西白云山盈康药业有限公司"
          : "阿苯达唑咀嚼⽚0.1g /12⽚ /盒 /缓释胶囊 /广西白云山盈康药业有限公司",
      origin: "广西白云山盈康药业有限公司",
      lstdLicHolder: "杨静云",
      approvalNumber: "国药准字H45021041",
      batchNo: "",
      arrivalUnitPrice: "13.40000",
      retailPrice: "14.50000",
      productDate: "20250803",
      deadline: "20290806",
      totalQuantity: "100",
      qualifiedQuantity: "100",
      defectiveQuantity: "0",
      qualityStatus: "良好",
      acceptanceConclusion: "合格",
      remark: "",
    },
  ]

  const zyData = [
    {
      groupNumber: "1",
      name: "桂枝",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 9,
      normalUsemethod: "无",
      cabineNo: "c01",
    },
    {
      groupNumber: "2",
      name: "木香",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 10,
      normalUsemethod: "后下",
      cabineNo: "c02",
    },
    {
      groupNumber: "3",
      name: "杏仁",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 6,
      normalUsemethod: "煎服",
      cabineNo: "c03",
    },
    {
      groupNumber: "4",
      name: "厚朴",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 6,
      normalUsemethod: "煎服",
      cabineNo: "c04",
    },
    {
      groupNumber: "5",
      name: "阿胶",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 5,
      normalUsemethod: "烊化",
      cabineNo: "c05",
    },
    {
      groupNumber: "6",
      name: "生姜",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 9,
      normalUsemethod: "无",
      cabineNo: "c06",
    },
    {
      groupNumber: "7",
      name: "白芍",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 9,
      normalUsemethod: "无",
      cabineNo: "c07",
    },
    {
      groupNumber: "8",
      name: "大枣 ",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 12,
      normalUsemethod: "无",
      cabineNo: "c08",
    },
    {
      groupNumber: "9",
      name: "炙甘草",
      countPerTip: 1,
      splitUnit: "g",
      drugCount: 6,
      normalUsemethod: "无",
      cabineNo: "c09",
    },
  ]

  const accepetUserMessage = {
    name: "张云月",
    arrivalDate: '2025-08-08',
    arrivalOrderNumber: '8567854345',
    supplierName: '华润医药有限公司',
    procurementDate: '2025-08-07',
    procurementNumber: '7553456444',
    createUser: '陈岳洋',
    acceptanceDate: '2025-08-08',
    documentCreator: '黄小旭',
    printDate: '2025-08-08 13:34',
  }

  const recipeTypeList = [{ name: "入库验收单", id: "1" }]

  const title = (name: any) => {
    return (
      <div className={styles.titleContent}>
        <div className={styles.title}>{name}</div>
      </div>
    )
  }

  const getRecipeTitleText = (flag: any) => {
    switch (flag) {
      case "1":
        return "验收单"
    }
  }

  useEffect(() => {

    // 获取正常的
    dispatch(getPrintTemplateSettingUserList({ stationType: 3, state: 1 }))
      .then(unwrapResult)
      .then((users: any) => {
        setElseUsers(users)
      })
      .catch(() => {
        // do nothing.
      })
  }, [])

  useEffect(() => {
    if (initialized === LoadingState.Idle) {
      dispatch(initializePrintService())
        .then(unwrapResult)
        .catch(() => {
          // do nothing.
        })
    }
    if (initialized === LoadingState.Finished) {
      dispatch(getPrinters())
    }
  }, [dispatch, initialized])

  useEffect(() => {
    if (props?.selectKey == "5") {
      getDetail()
    }
  }, [props?.selectKey, selectButtonId])

  const getDetail = () => {
    const id =
      selectButtonId == "1"
        ? "PurchAseacceptance"
        : ""
    dispatch(getPrintSettingDetailAsync({ templateCode: id }))
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) === "{}") {
          setIsMask(true)
          return
        } else {
          setIsMask(false)
        }
        setDetail(v)
        const headerMain: any = {
          direction: v?.globalConfig?.direction,
          paperSizeUnlimited: v?.globalConfig?.paperSizeUnlimited,
          topMargin: v?.globalConfig?.topMargin,
          leftMargin: v?.globalConfig?.leftMargin,
          font: v?.globalConfig?.font,
        }
        const titlePatientMessage: any ={
                titleName: v?.headerConfig?.titleName,
                arrivalDate: v?.headerConfig?.first_line?.arrivalDate,
                arrivalOrderNumber: v?.headerConfig?.first_line?.arrivalOrderNumber,
                supplierName: v?.headerConfig?.first_line?.supplierName,
                procurementDate: v?.headerConfig?.second_line?.procurementDate,
                procurementNumber: v?.headerConfig?.second_line?.procurementNumber,
              }
        const contentMessage: any =
          selectButtonId == "1"
            ? {
                no: v?.bodyConfig?.first_line?.no,
                productInformation: v?.bodyConfig?.first_line?.productInformation,
                origin: v?.bodyConfig?.first_line?.origin,
                lstdLicHolder: v?.bodyConfig?.first_line?.lstdLicHolder,
                approvalNumber: v?.bodyConfig?.second_line?.approvalNumber,
                batchNo: v?.bodyConfig?.second_line?.batchNo,
                arrivalUnitPrice: v?.bodyConfig?.second_line?.arrivalUnitPrice,
                retailPrice: v?.bodyConfig?.second_line?.retailPrice,
                productDate: v?.bodyConfig?.third_line?.productDate,
                deadline: v?.bodyConfig?.third_line?.deadline,
                totalQuantity: v?.bodyConfig?.third_line?.totalQuantity,
                qualifiedQuantity: v?.bodyConfig?.third_line?.qualifiedQuantity,
                defectiveQuantity: v?.bodyConfig?.fourth_line?.defectiveQuantity,
                qualityStatus: v?.bodyConfig?.fourth_line?.qualityStatus,
                acceptanceConclusion: v?.bodyConfig?.fourth_line?.acceptanceConclusion,
                remark: v?.bodyConfig?.fourth_line?.remark,
              }
            : {}

        const ysrData = {
          // 验收人
          acceptanceUserId: v?.userSignConfig?.acceptanceUser?.doctorId,
          acceptanceUserType: v?.userSignConfig?.acceptanceUser?.signatureContent,
        }
        const bottomMessage: any = {
          printDate: v?.footerConfig?.printDate,
          createUser: v?.footerConfig?.createUser,
          acceptanceDate: v?.footerConfig?.acceptanceDate,
          documentCreator: v?.footerConfig?.documentCreator,
          systemPrintOrHandwriting: v?.footerConfig?.systemPrintOrHandwriting,
          ...ysrData
        }
        form.setFieldsValue({
          ...headerMain,
          ...titlePatientMessage,
          ...contentMessage,
          ...bottomMessage,
        })

        // 验收人
        setAcceptanceUserSignType(v?.userSignConfig?.acceptanceUser?.useESign)
        setAcceptanceUserTypeListFlag(
          v?.userSignConfig?.acceptanceUser?.signatureContent == 1 ? true : false
        )

        const changeDatas = {
          ...titlePatientMessage,
          ...contentMessage,
          ...bottomMessage,
        }
        setChangeData({ ...changeDatas })
      })
  }
  return (
    <div className={styles.container}>
      {isMask ? (
        <div className={styles.containerMask}>
          <span>新版模板：支持个性化编辑</span>
          <Button
            onClick={() => {
              const id =
                selectButtonId == "1"
                  ? "PurchAseacceptance"
                  : ""
              dispatch(getPrintInitOneConfigAsync({ templateCode: id }))
                .then(unwrapResult)
                .then(() => {
                  getDetail()
                })
            }}
            style={{
              background: "#027AFF",
              color: "#FFFFFF",
              width: 120,
              height: 40,
              lineHeight: "30px",
            }}
          >
            开启模板
          </Button>
        </div>
      ) : (
        <></>
      )}
      <Row className={styles.recipePrintContent}>
        <Col className={styles.leftContent}>
          <Col span={24} className={styles.recipeTypeButtonMain}>
            {recipeTypeList?.map((v: any) => {
              return (
                <Button
                  key={v?.id}
                  type={v?.id == selectButtonId ? "primary" : "ghost"}
                  style={{ marginLeft: "8px" }}
                  onClick={() => {
                    setSelectButtonId(v?.id)
                    setChangeData({})
                  }}
                >
                  {v?.name}
                </Button>
              )
            })}
          </Col>
          <div className={styles.leftBottomFormContent}>
            <Form
              form={form}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              autoComplete="off"
              onFinish={(values: any) => {
                if (values?.acceptanceUserType == 1 && !values?.acceptanceUserId) {
                  notification.info({
                    message: "请选择固定验收人",
                  })
                  return
                }
                const params: any =
                  selectButtonId == "1"
                    ? {
                        id: detail?.id,
                        templateId: detail?.templateId,
                        globalConfig: {
                          direction: 0,
                          topMargin: Number(values?.topMargin),
                          leftMargin: Number(values?.leftMargin),
                          paperSizeUnlimited: values?.paperSizeUnlimited,
                          font: values?.font,
                        },
                        headerConfig: {
                          titleName: values?.titleName,
                          first_line: {
                            arrivalDate: values?.arrivalDate,
                            arrivalOrderNumber: values?.arrivalOrderNumber,
                            supplierName: values?.supplierName,
                          },
                          second_line: {
                            procurementDate: values?.procurementDate,
                            procurementNumber: values?.procurementNumber,
                          },
                        },
                        bodyConfig: {
                          first_line: {
                            no: values?.no,
                            productInformation: values?.productInformation,
                            origin: values?.origin,
                            lstdLicHolder: values?.lstdLicHolder,
                          },
                          second_line: {
                            approvalNumber: values?.approvalNumber,
                            batchNo: values?.batchNo,
                            arrivalUnitPrice: values?.arrivalUnitPrice,
                            retailPrice: values?.retailPrice,
                          },
                          third_line: {
                            productDate: values?.productDate,
                            deadline: values?.deadline,
                            totalQuantity: values?.totalQuantity,
                            qualifiedQuantity: values?.qualifiedQuantity,
                          },
                          fourth_line: {
                            defectiveQuantity: values?.defectiveQuantity,
                            qualityStatus: values?.qualityStatus,
                            acceptanceConclusion: values?.acceptanceConclusion,
                            remark: values?.remark,
                          },
                        },
                        userSignConfig: {
                          acceptanceUser: {
                            doctorId: values?.acceptanceUserId,
                            signatureContent: values?.acceptanceUserType,
                            useESign: acceptanceUserSignType,
                          },
                        },
                        footerConfig: {
                          printDate: values?.printDate,
                          createUser: values?.createUser,
                          acceptanceDate: values?.acceptanceDate,
                          documentCreator: values?.documentCreator,
                          systemPrintOrHandwriting: values?.systemPrintOrHandwriting,
                        },
                      }
                    : {}
                setButtonLoading(true)
                dispatch(getPrintSettingSubmitAsync(params))
                  .then(unwrapResult)
                  .then((v: any) => {
                    setButtonLoading(false)
                    notification.success({
                      message: "操作成功",
                    })
                    getDetail()
                  })
              }}
            >
              {title("全局信息")}
              {/* <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item label="纸张进入方向" name="direction">
                    <Radio.Group
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Col span={5}>
                        <Radio value={0}>横版</Radio>
                      </Col>
                      <Col span={19} style={{ position: "relative" }}>
                        <Radio value={1}>竖版</Radio>
                      </Col>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row> */}
              <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item
                    label={"限制纸张大小"}
                    name="paperSizeUnlimited"
                    valuePropName="checked"
                  >
                    <Checkbox>开启</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row className={styles.rowHeight}>
                <Col span={4}>偏移量</Col>
                <Col span={10}>
                  <Row className={styles.alignItemsCenter}>
                    上偏移量
                    <Form.Item label="" name="topMargin">
                      <Input
                        type="number"
                        style={{ width: "90px", marginLeft: "10px" }}
                      />
                    </Form.Item>
                    （毫米）
                  </Row>
                </Col>
                <Col span={10}>
                  <Row className={styles.alignItemsCenter}>
                    左偏移量
                    <Form.Item label="" name="leftMargin">
                      <Input
                        type="number"
                        style={{ width: "90px", marginLeft: "10px" }}
                      />
                    </Form.Item>
                    （毫米）
                  </Row>
                </Col>
              </Row>
              <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item label='字体' name='font'>
                    <Radio.Group
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                      }}
                      onChange={(e) => {
                        setChangeData({
                          ...changeData,
                          font: e.target?.value
                        })
                      }}
                    >
                      <Col span={5}>
                        <Radio value={0} >
                          黑体 
                        </Radio>
                      </Col>
                      <Col span={19}>
                        <Radio value={1}>
                          宋体 
                        </Radio>
                      </Col>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {title("头部信息")}
              <Row className={styles.rowHeight}>
                <Col span={4}>抬头名称</Col>
                <Col span={20}>
                  <Row className={styles.alignItemsCenter}>
                    <Form.Item label="" name="titleName">
                      <Input
                        style={{ width: "380px" }}
                        suffix={getRecipeTitleText(selectButtonId)}
                        onChange={(e) => {
                          setChangeData({
                            ...changeData,
                            titleName: e?.target?.value,
                          })
                        }}
                      />
                    </Form.Item>
                    <span
                      className={styles.nameTips}
                      onClick={() => {
                        dispatch(
                          getPrintSettingsyncTenantNameAsync({
                            tenantName: changeData?.titleName,
                          })
                        )
                          .then(unwrapResult)
                          .then((v) => {
                            notification.success({
                              message: "操作成功",
                            })
                          })
                      }}
                    >
                      运用至全部
                    </span>
                  </Row>
                </Col>
              </Row>
              {selectButtonId == "1" && (
                <Row className={styles.radioWidth6}>
                  <Col span={4} style={{ marginTop: "8px" }}>
                    抬头信息
                  </Col>
                  <Col span={20}>
                    <Row>
                      <Col span={6}>
                        <Form.Item name="arrivalDate" valuePropName="checked">
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                arrivalDate: e?.target?.checked,
                              })
                            }}
                          >
                            到货日期
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="arrivalOrderNumber"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                arrivalOrderNumber: e?.target?.checked,
                              })
                            }}
                          >
                            到货单号
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item name="supplierName" valuePropName="checked">
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                supplierName: e?.target?.checked,
                              })
                            }}
                          >
                            供应商
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}></Col>
                      <Col span={6}>
                        <Form.Item
                          name="procurementDate"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                procurementDate: e?.target?.checked,
                              })
                            }}
                          >
                            采购日期
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="procurementNumber"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                procurementNumber: e?.target?.checked,
                              })
                            }}
                          >
                            采购单号
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {title("正文")}
              {
                // 入库验收单
                selectButtonId == "1" ? (
                  <>
                    <Row className={styles.radioWidth6}>
                      <Col span={4} style={{ marginTop: "8px" }}>
                        明细内容
                      </Col>
                      <Col span={20}>
                        <Row>
                          <Col span={6}>
                            <Form.Item name="no" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    no: e?.target?.checked,
                                  })
                                }}
                              >
                                商品编号
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="productInformation"
                              valuePropName="checked"
                            >
                              <Checkbox disabled>产品信息</Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item name="origin" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    origin: e?.target?.checked,
                                  })
                                }}
                              >
                                产地
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="lstdLicHolder"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    lstdLicHolder: e?.target?.checked,
                                  })
                                }}
                              >
                                上市许可持有人
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <Form.Item
                              name="approvalNumber"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    approvalNumber: e?.target?.checked,
                                  })
                                }}
                              >
                                批准文号
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item name="batchNo" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    batchNo: e?.target?.checked,
                                  })
                                }}
                              >
                                批号
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="arrivalUnitPrice"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    arrivalUnitPrice: e?.target?.checked,
                                  })
                                }}
                              >
                                购进价格
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="retailPrice"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    retailPrice: e?.target?.checked,
                                  })
                                }}
                              >
                                零售价格
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <Form.Item
                              name="productDate"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    productDate: e?.target?.checked,
                                  })
                                }}
                              >
                                生产日期
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item name="deadline" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    deadline: e?.target?.checked,
                                  })
                                }}
                              >
                                有效期至
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="totalQuantity"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    totalQuantity: e?.target?.checked,
                                  })
                                }}
                              >
                                到货数量
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="qualifiedQuantity"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    qualifiedQuantity: e?.target?.checked,
                                  })
                                }}
                              >
                                验收合格数量
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <Form.Item
                              name="defectiveQuantity"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    defectiveQuantity: e?.target?.checked,
                                  })
                                }}
                              >
                                验收不合格数量
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="qualityStatus"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    qualityStatus: e?.target?.checked,
                                  })
                                }}
                              >
                                质量状况
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="acceptanceConclusion"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    acceptanceConclusion: e?.target?.checked,
                                  })
                                }}
                              >
                                验收结论
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item name="remark" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    remark: e?.target?.checked,
                                  })
                                }}
                              >
                                备注
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )
              }

              {title("尾部信息")}

              <>
                <Row className={styles.radioWidth12}>
                  <Col span={4} style={{ marginTop: "8px" }}>
                    尾部信息
                  </Col>
                  <Col span={20}>
                    <Row>
                      <Col span={6}>
                        <Form.Item name="printDate" valuePropName="checked">
                          <Checkbox
                            onChange={(e: any) => {
                              setChangeData({
                                ...changeData,
                                printDate: e?.target?.checked,
                              })
                            }}
                          >
                            打印时间
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item name="createUser" valuePropName="checked">
                          <Checkbox
                            onChange={(e: any) => {
                              setChangeData({
                                ...changeData,
                                createUser: e?.target?.checked,
                              })
                            }}
                          >
                            验收人
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="acceptanceDate"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e: any) => {
                              setChangeData({
                                ...changeData,
                                acceptanceDate: e?.target?.checked,
                              })
                            }}
                          >
                            验收日期
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="documentCreator"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e: any) => {
                              setChangeData({
                                ...changeData,
                                documentCreator: e?.target?.checked,
                              })
                            }}
                          >
                            制单人
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={4} style={{ marginTop: "7px" }}>
                    验收人
                  </Col>
                  <Col span={20}>
                    <Row
                      style={{ height: "40px" }}
                      className={styles.alignItemsCenter}
                    >
                      <div
                        style={{ width: "140px", marginRight: "20px" }}
                        className={styles.alignItemsCenter}
                      >
                        <Form.Item name="acceptanceUserType" label="">
                          <Select
                            placeholder=""
                            style={{ width: "140px" }}
                            onChange={(v) => {
                              if (v == 1) {
                                setAcceptanceUserTypeListFlag(true)
                              } else {
                                setAcceptanceUserTypeListFlag(false)
                              }
                              setChangeData({
                                ...changeData,
                                acceptanceUserType: v,
                              })
                            }}
                          >
                            <Select.Option key={0} value={0}>
                              确认验收人员
                            </Select.Option>
                            <Select.Option key={1} value={1}>
                              固定人员
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </div>
                      {showAcceptanceUserTypeListFlag && (
                        <div
                          style={{ width: "140px", marginRight: "20px" }}
                          className={styles.alignItemsCenter}
                        >
                          <Form.Item name="acceptanceUserId" label="">
                            <Select
                              placeholder="请选择医生"
                              style={{ width: "140px" }}
                              onChange={(v) => {
                                setChangeData({
                                  ...changeData,
                                  acceptanceUserId: v,
                                })
                              }}
                            >
                              {elseUsers?.map((u: any) => (
                                <Select.Option
                                  key={Number(u.id)}
                                  value={Number(u.id)}
                                >
                                  {u.realname}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      )}
                      <div
                        className={styles.alignItemsCenter}
                        style={{ width: "130px" }}
                      >
                        <Checkbox
                          checked={acceptanceUserSignType}
                          onChange={(v) => {
                            setAcceptanceUserSignType(v?.target.checked)
                          }}
                        >
                          使用电子签名
                        </Checkbox>
                      </div>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.rowHeight}>
                  <Col span={24}>
                    <Form.Item label="验收日期" name="systemPrintOrHandwriting">
                      <Radio.Group
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                        onChange={(e: any) => {
                          setChangeData({
                            ...changeData,
                            systemPrintOrHandwriting: e?.target?.value,
                          })
                        }}
                      >
                        <Col span={5}>
                          <Radio value={0}>系统打印</Radio>
                        </Col>
                        <Col span={19} style={{ position: "relative" }}>
                          <Radio value={1}>手写</Radio>
                        </Col>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </>

              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "30px 0",
                  position: "fixed",
                  bottom: 0,
                  left: "29%",
                }}
              >
                <Button
                  ghost
                  loading={buttonLoading}
                  style={{
                    color: "#101010",
                    border: "1px solid #BBBBBB",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    Modal.confirm({
                      centered: true,
                      title: "",
                      content: <div>是否确认恢复系统默认？</div>,
                      okText: "确认",
                      cancelText: "取消",
                      icon: null,
                      onOk: () => {
                        const id = selectButtonId == "1" ? "PurchAseacceptance" : ""
                        dispatch(
                          getPrintRestoreConfigDefaultAsync({
                            templateCode: id,
                          })
                        )
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: "操作成功",
                            })
                            getDetail()
                          })
                      },
                    })
                  }}
                >
                  恢复系统默认
                </Button>
                <Button
                  loading={buttonLoading}
                  style={{ background: "#027AFF", color: "#FFFFFF" }}
                  htmlType="submit"
                >
                  保存
                </Button>
              </Row>
            </Form>
          </div>
        </Col>
        <Col className={`${styles.rightContent} ${changeData?.font == 1 ? styles.fontSong : styles.fontHei}`} style={{ width: "700px" }}>
          <div className={styles.rightContentTitle}>
            <span>{'入库验收单'}</span>
            <div className={styles.titleButton}>
              <Button
                type={"primary"}
                style={{ marginRight: "8px" }}
                onClick={async () => {
                  const params =
                    selectButtonId == "1"
                      ? { templateCode: "PurchAseacceptance", setupFlag: true }
                      : {}
                  await dispatch(getPrintSettingEditOrYLAsync(params))
                }}
              >
                编辑
              </Button>
              <Button
                type={"primary"}
                style={{ marginRight: "8px" }}
                onClick={async () => {
                  const params =
                    selectButtonId == "1"
                      ? { templateCode: "PurchAseacceptance", setupFlag: false }
                      : {}
                  await dispatch(getPrintSettingEditOrYLAsync(params))
                }}
              >
                打印效果
              </Button>
            </div>
          </div>
          <div className={styles.rightContentMain}>
            {/* 机构名 */}
            <div className={styles.tenantNameTitle}>
              {changeData?.titleName}
            </div>

            {/* 头部信息 */}
            <div className={styles.subTitleMain}>
              <Col span={24} className={styles.subTitleMainCenter}>
                {getRecipeTitleText(selectButtonId)}
              </Col>
            </div>

            {/* 采购验收记录*/}
            <div className={styles.recipeContent} style={{ marginTop: 4 }}>
              <Row gutter={10} className={styles.TextStyleLine}>
                {changeData?.arrivalDate && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>到货日期：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.arrivalDate}
                    </div>
                  </Col>
                )}
                {changeData?.arrivalOrderNumber && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>到货单号：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.arrivalOrderNumber}
                    </div>
                  </Col>
                )}
                {changeData?.supplierName && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleThreeTextStyle}>供应商：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.supplierName}
                    </div>
                  </Col>
                )}
                </Row>
                <Row gutter={10} className={styles.TextStyleLine}>
                {changeData?.procurementDate && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>采购日期：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.procurementDate}
                    </div>
                  </Col>
                )}
                {changeData?.procurementNumber && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>采购单号：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.procurementNumber}
                    </div>
                  </Col>
                )}
              </Row>
            </div>

            <div style={{ marginTop: "4px" }}>
              <div className={styles.treatmentPrintContents}>
                <table
                  className={styles.treatmentPrintTable}
                  style={{ fontSize: 8 }}
                >
                  <thead style={{ height: "30px", background: "#e8e8e8" }}>
                    <tr>
                      {changeData?.no && <th>商品编号</th>}
                      <th>产品信息</th>
                      {changeData?.origin && <th>产地</th>}
                      {changeData?.lstdLicHolder && <th>上市许可持有人</th>}
                      {changeData?.approvalNumber && <th>批准文号</th>}
                      {changeData?.batchNo && <th>批号</th>}
                      {changeData?.arrivalUnitPrice && <th>购进价格</th>}
                      {changeData?.retailPrice && <th>零售价格</th>}
                      {changeData?.productDate && <th>生产日期</th>}
                      {changeData?.deadline && <th>有效期至</th>}
                      {changeData?.totalQuantity && <th>到货数量</th>}
                      {changeData?.qualifiedQuantity && <th>验收合格数量</th>}
                      {changeData?.defectiveQuantity && <th>验收不合格数</th>}
                      {changeData?.qualityStatus && <th>质量状况</th>}
                      {changeData?.acceptanceConclusion && <th>验收结论</th>}
                      {changeData?.remark && <th>备注</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {rkysdDataList?.map((t: any, i: number) => {
                      return (
                        <tr key={i}>
                          {changeData?.no && (
                            <td style={{ width: "6%" }}>{t?.no}</td>
                          )}
                          <td style={{ width: "14%" }}>
                            {t?.productInformation}
                          </td>
                          {changeData?.origin && (
                            <td style={{ width: "6%" }}>{t?.origin}</td>
                          )}
                          {changeData?.lstdLicHolder && (
                            <td style={{ width: "6%" }}>{t?.lstdLicHolder}</td>
                          )}
                          {changeData?.approvalNumber && (
                            <td style={{ width: "6%" }}>{t?.approvalNumber}</td>
                          )}
                          {changeData?.batchNo && (
                            <td style={{ width: "6%" }}>{t?.batchNo}</td>
                          )}
                          {changeData?.arrivalUnitPrice && (
                            <td style={{ width: "6%" }}>
                              {t?.arrivalUnitPrice}
                            </td>
                          )}
                          {changeData?.retailPrice && (
                            <td style={{ width: "6%" }}>{t?.retailPrice}</td>
                          )}
                          {changeData?.productDate && (
                            <td style={{ width: "6%" }}>{t?.productDate}</td>
                          )}
                          {changeData?.deadline && (
                            <td style={{ width: "6%" }}>{t?.deadline}</td>
                          )}
                          {changeData?.totalQuantity && (
                            <td style={{ width: "6%" }}>{t?.totalQuantity}</td>
                          )}
                          {changeData?.qualifiedQuantity && (
                            <td style={{ width: "5%" }}>
                              {t?.qualifiedQuantity}
                            </td>
                          )}
                          {changeData?.defectiveQuantity && (
                            <td style={{ width: "5%" }}>
                              {t?.defectiveQuantity}
                            </td>
                          )}
                          {changeData?.qualityStatus && (
                            <td style={{ width: "6%" }}>{t?.qualityStatus}</td>
                          )}
                          {changeData?.acceptanceConclusion && (
                            <td style={{ width: "6%" }}>
                              {t?.acceptanceConclusion}
                            </td>
                          )}
                          {changeData?.remark && (
                            <td style={{ width: "4%" }}>{t?.remark}</td>
                          )}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className={styles.recipeContent} style={{ marginTop: 12 }}>
              <Row gutter={10} className={styles.TextStyleLine}>
                {changeData?.createUser && (
                  <Col span={5} className={styles.TextStyle}>
                    <div className={styles.titleThreeTextStyle}>验收人：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {showAcceptanceUserTypeListFlag && changeData?.acceptanceUserId  ? 
                        elseUsers?.find((item: any) => item.id == changeData?.acceptanceUserId)?.realname
                       : accepetUserMessage?.createUser}
                    </div>
                  </Col>
                )}
                {changeData?.acceptanceDate && (
                  <Col span={6} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>验收日期：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {changeData?.systemPrintOrHandwriting == 0 ? accepetUserMessage?.acceptanceDate : ''}
                    </div>
                  </Col>
                )}
                {changeData?.documentCreator && (
                  <Col span={5} className={styles.TextStyle}>
                    <div className={styles.titleThreeTextStyle}>制单人：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.documentCreator}
                    </div>
                  </Col>
                )}
                {changeData?.printDate && (
                  <Col span={8} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>打印时间：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {accepetUserMessage?.printDate}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
